/**
 * @generated SignedSource<<d632fce123b2650e0730c4a86fab4579>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InspectionFormOverviewStartMutation$variables = {
  inspectionfield: string;
  inspectionform: string;
};
export type InspectionFormOverviewStartMutation$data = {
  readonly startInspection: {
    readonly inspection: {
      readonly id: string;
      readonly inspectionfield: {
        readonly " $fragmentSpreads": FragmentRefs<"InspectionDetailsContainer" | "InspectionFormOverview">;
      };
    } | null;
  } | null;
};
export type InspectionFormOverviewStartMutation = {
  response: InspectionFormOverviewStartMutation$data;
  variables: InspectionFormOverviewStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inspectionfield"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inspectionform"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "inspectionfield",
        "variableName": "inspectionfield"
      },
      {
        "kind": "Variable",
        "name": "inspectionform",
        "variableName": "inspectionform"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberNode",
  "kind": "LinkedField",
  "name": "member",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyNode",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AddressNodeConnection",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AddressNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AddressNode",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "street",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "houseNumber",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "zipcode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "city",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionFormOverviewStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StartInspectionMutationPayload",
        "kind": "LinkedField",
        "name": "startInspection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionNode",
            "kind": "LinkedField",
            "name": "inspection",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionfieldNode",
                "kind": "LinkedField",
                "name": "inspectionfield",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "InspectionFormOverview"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "InspectionDetailsContainer"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "InspectionFormOverviewStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StartInspectionMutationPayload",
        "kind": "LinkedField",
        "name": "startInspection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionNode",
            "kind": "LinkedField",
            "name": "inspection",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionfieldNode",
                "kind": "LinkedField",
                "name": "inspectionfield",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalId",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectNode",
                    "kind": "LinkedField",
                    "name": "managementPackageVariant",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ManagementPackageNode",
                        "kind": "LinkedField",
                        "name": "managementPackage",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionNode",
                    "kind": "LinkedField",
                    "name": "latestInspection",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastModified",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InspectionFormNode",
                        "kind": "LinkedField",
                        "name": "inspectionform",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "approvedDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rejectedDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "retryDate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionFormNodeConnection",
                    "kind": "LinkedField",
                    "name": "inspectionforms",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InspectionFormNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InspectionFormNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v7/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FieldNode",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previousId",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "periodStart",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "periodEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "reason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notes",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ManagementPackageSettingsNode",
                    "kind": "LinkedField",
                    "name": "managementPackageSetting",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pdfFileUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayNameAlt",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b49064f46eadc7dcba41efecb327489f",
    "id": null,
    "metadata": {},
    "name": "InspectionFormOverviewStartMutation",
    "operationKind": "mutation",
    "text": "mutation InspectionFormOverviewStartMutation(\n  $inspectionform: ID!\n  $inspectionfield: ID!\n) {\n  startInspection(input: {inspectionform: $inspectionform, inspectionfield: $inspectionfield}) {\n    inspection {\n      id\n      inspectionfield {\n        ...InspectionFormOverview\n        ...InspectionDetailsContainer\n        id\n      }\n    }\n  }\n}\n\nfragment InspectionDetailsContainer on InspectionfieldNode {\n  year\n  name\n  state\n  plannedDate\n  periodStart\n  periodEnd\n  assignedDate\n  reason\n  notes\n  latestInspection {\n    approvedDate\n    rejectedDate\n    lastModified\n    retryDate\n    id\n  }\n  member {\n    name\n    phone\n    email\n    company {\n      address {\n        edges {\n          node {\n            id\n            street\n            houseNumber\n            zipcode\n            city\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  managementPackageSetting {\n    pdfFileUrl\n    displayNameAlt\n    id\n  }\n  field {\n    id\n    year\n    previousId\n    member {\n      name\n      phone\n      email\n      company {\n        address {\n          edges {\n            node {\n              id\n              street\n              houseNumber\n              zipcode\n              city\n            }\n          }\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment InspectionFormOverview on InspectionfieldNode {\n  id\n  externalId\n  year\n  state\n  plannedDate\n  assignedDate\n  managementPackageVariant {\n    code\n    name\n    managementPackage {\n      name\n      id\n    }\n    id\n  }\n  latestInspection {\n    id\n    state\n    lastModified\n    inspectionform {\n      id\n      year\n    }\n  }\n  inspectionforms {\n    edges {\n      node {\n        id\n        year\n      }\n    }\n  }\n  field {\n    year\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e8514678478f5ac7a158269608f6040";

export default node;
